import { render, staticRenderFns } from "./AsociarMensajesFormDetalle.vue?vue&type=template&id=5d219c32&scoped=true&"
import script from "./AsociarMensajesFormDetalle.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesFormDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesFormDetalle.vue?vue&type=style&index=0&id=5d219c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d219c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d219c32', component.options)
    } else {
      api.reload('5d219c32', component.options)
    }
    module.hot.accept("./AsociarMensajesFormDetalle.vue?vue&type=template&id=5d219c32&scoped=true&", function () {
      api.rerender('5d219c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarMensajesFormDetalle.vue"
export default component.exports